module.exports = __webpack_public_path__ + "static/billsby-cart-4ab3d39911b40547bdab6c3bb7a34341.svg";